/**
 * MyAgent System Prompts
 *
 * Default system prompts and prompt configurations for MyAgent
 */

export const MYAGENT_BOT_ID = '__myagent__'

/**
 * Default myagent bot config (built-in, not stored in user data)
 */
export const MYAGENT_DEFAULT_CONFIG = {
  botId: MYAGENT_BOT_ID,
  displayName: 'MyAgent',
  description: 'Your AI assistant',
  llm: {
    mode: 'remote',
    provider: null,
    model: null,
    apiKey: null,
    workerPublicKey: null,
  },
  role: {
    systemPrompt: null,
  },
  isBuiltIn: true,
}

/**
 * Build the default MyAgent role description
 */
function defaultRolePrompt() {
  return `You are MyAgent, the host bot in a group conversation. You are the user's primary AI assistant.

Rules:
- Present yourself as MyAgent, not as any specific AI model
- Respond in the user's language
- When you need to perform actions (notes, web search, notifications, etc.), @mention @tools with a natural language description of what you need
- When other participants are available and you need their help, @mention them in your response
- The user talks to you by default; other participants receive your @mentions and will reply in the next turn`
}

/**
 * Build system prompt for a specific bot config
 * @param {Object} botConfig - Bot configuration (from bot-config.js)
 * @param {string} [participantPrompt] - Optional participant section (injected by chat engine)
 * @returns {string}
 */
export function buildBotSystemPrompt(botConfig, participantPrompt) {
  const roleDesc = botConfig?.role?.systemPrompt || defaultRolePrompt()
  const parts = [roleDesc]
  if (participantPrompt) parts.push(participantPrompt)
  return parts.join('\n\n')
}
